// 'use client';
// import { useLocale } from 'next-intl';
// import config from '@/api/global';

// const routerPath = (path) => {
//   const locale = useLocale();
//   if (locale == config.defaultLocale) {
//     return `${path}`;
//   } else {
//     return `/${locale}${path}`;
//   }
// };

// export default routerPath;

// =========

// useRouterPath.js
'use client';
import config from '@/api/global';
import { useLocale } from 'next-intl';
// import config from '@/api/global';

export const useRouterPath = () => {
  const locale = useLocale();

  return (path) => {
    if (locale === config.defaultLocale) {
      return `${path}`;
    } else {
      return `/${locale}${path}`;
    }
  };
};
